import * as STD from '@emersya/mpa-std-lib';
import CM from '@emersya/mpa-components-manager-lib';

export type TTextTypes = (
	'title-1' | 'title-2' | 'title-3' | 'title-4' | 'title-5' | 'title-6' |
	'label' |
	'paragraph' |
	'block'
	);
export type TDOMRepresentation = HTMLDivElement | HTMLParagraphElement | HTMLHeadingElement | HTMLLabelElement;

export interface ITextComponentConfiguration extends CM.DOMComponent.IConfiguration {
	type?: TTextTypes;
};

export class TextComponent extends CM.DOMComponent<
	TDOMRepresentation,
	TextComponent,
	ITextComponentConfiguration
> {
	component_DOM: TDOMRepresentation;
	text: string | null = null;

	update(text: string) {
		this.component_DOM.textContent = text;
		this.text = text;
	};

	override async component_finalize() {
		await super.component_finalize();
		if (this.component_hasTranslation('text')) {
			const trId = this.component_getTranslationId('text');
			this.component_DOM.dataset.translation = trId;
			this.text = '\0' + trId;
		}
	};

	constructor(
		descriptor: ConstructorParameters<typeof CM.Component>[0],
		configuration: ITextComponentConfiguration
	) {
		super(descriptor, configuration);
		if (!this.component_configuration.type) {
			this.component_configuration.type = 'block';
		}
		if (this.component_configuration.type === 'label') {
			this.component_DOM = <HTMLLabelElement>STD.DOM.factory({tag: 'label'});
		} else if (this.component_configuration.type === 'paragraph') {
			this.component_DOM = <HTMLDivElement>STD.DOM.factory({tag: 'p'});
		} else if (this.component_configuration.type === 'block') {
			this.component_DOM = <HTMLDivElement>STD.DOM.factory({});
		} else if (this.component_configuration.type.startsWith('title-')) {
			this.component_DOM =
				<HTMLDivElement>STD.DOM.factory({tag: this.component_configuration.type.replace('title-', 'h')});
		} else {
			this.component_throwUserError('Invalid configuration.type value!', {
				'configuration.type': this.component_configuration.type
			});
		}
	};
};
export namespace NS {
	export type Component = TextComponent;
	export const Component = TextComponent;
	export type Configuration = ITextComponentConfiguration;
}
;
CM.declare({
	id: 'text',
	type: TextComponent
});
